/** Where to go when there is no in-app `from` and browser history cannot help. */
export function defaultBackPath(account) {
  return account ? "/events" : "/";
}

/** Label for that default destination. */
export function defaultBackLabel(account) {
  return account ? "Events" : "Home";
}

function resolveFrom(location) {
  const from = location?.state?.from;
  if (typeof from !== "string") return null;
  const trimmed = from.trim();
  return trimmed || null;
}

/** True when React Router (or the browser) has an in-app entry to pop. */
export function canGoBackInHistory() {
  if (typeof window === "undefined") return false;
  const idx = window.history.state?.idx;
  if (typeof idx === "number") return idx > 0;
  return window.history.length > 1;
}

/** Navigate to the previous screen when possible, with sensible fallbacks. */
export function goBack(nav, location, fallbacks = []) {
  const from = resolveFrom(location);
  if (from) {
    nav(from);
    return;
  }
  if (canGoBackInHistory()) {
    nav(-1);
    return;
  }
  const target = fallbacks.find((path) => typeof path === "string" && path.trim()) || "/events";
  nav(target);
}

/** Label for back controls: "Back" when we can return somewhere, else a fallback. */
export function backLabel(location, fallbackLabel = "Events") {
  if (resolveFrom(location)) return "Back";
  if (canGoBackInHistory()) return "Back";
  return fallbackLabel;
}
